document.addEventListener('DOMContentLoaded', () => {

  setTimeout(() => {
    const selectedOptions = document.querySelectorAll('.variant-picker__form select option[selected], .variant-picker__form fieldset input:checked');

    selectedOptions.forEach(option => {
      let variantName = option.getAttribute('name')
      if (variantName && variantName.includes('Color')) {
      let variantValue = option.value
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/\s+/g, '-')
        .toLowerCase();

        document.querySelectorAll('.custom__thumbnail-control').forEach(el => {
          if (!el.classList.contains(variantValue.toLowerCase())) {
            el.classList.add('not-show');
          } else {
            el.classList.remove('not-show');
          }
        });

        document.querySelectorAll('.custom-media-image-product').forEach(el => {

          if (!el.classList.contains(variantValue.toLowerCase())) {
            el.classList.add('not-show');
          } else {
            el.classList.remove('not-show');
          }
        });
        
      }
    });

  }, 300);


  if (!sessionStorage.getItem('open-cart-drawer')) return;
  sessionStorage.removeItem('open-cart-drawer');

  setTimeout(() => {
    document.querySelector(".cart-drawer .header-actions__action").click();
  }, 300);

});